module.exports = __webpack_public_path__ + "public/Icons/siteadminicon.png?acbc695f";